var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedMoney = function SvgRedMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2.821 6v3M13.18 7v3m2.071 1.674c-5.932 2.799-8.568-2.646-14.5.152v-7.5c5.932-2.799 8.568 2.646 14.5-.152zM9.554 8c0 .828-.696 1.5-1.554 1.5S6.446 8.828 6.446 8 7.142 6.5 8 6.5s1.554.672 1.554 1.5"
  })));
};
export default SvgRedMoney;